import { render, staticRenderFns } from "./VuesticPreLoader.vue?vue&type=template&id=c63fe428"
import script from "./VuesticPreLoader.vue?vue&type=script&lang=js"
export * from "./VuesticPreLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c63fe428')) {
      api.createRecord('c63fe428', component.options)
    } else {
      api.reload('c63fe428', component.options)
    }
    module.hot.accept("./VuesticPreLoader.vue?vue&type=template&id=c63fe428", function () {
      api.rerender('c63fe428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-preloader/VuesticPreLoader.vue"
export default component.exports